export let colorScheme = {
    domain: ['#00355E', '#BDCC42', '#DB6D00', '#DA33FF', '#5AA454', '#E44D25', '#CFC0BB', '#7AA3E5', '#A8385D', '#AAE3f5']
};
